import React from 'react';
import styles from './Context.module.css';
import { FiX, FiPlus } from 'react-icons/fi';
import { useFeatureFlipStore } from 'Store/featureFlipStore';
import EmptyState from '../EmptyState/EmptyState';

interface ContextBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateNew: () => void;
}

const ContextBottomSheet: React.FC<ContextBottomSheetProps> = ({
  isOpen,
  onClose,
  onCreateNew
}) => {
  const contexts = useFeatureFlipStore(s => s.contexts);

  if (!isOpen) return null;

  return (
    <div className={styles.bottomSheet}>
      <div className={styles.bottomSheetContent}>
        <div className={styles.bottomSheetHeader}>
          <div className={styles.dragHandle} />
          <h2>Contexts</h2>
          <button onClick={onClose} className={styles.closeButton}>
            <FiX />
          </button>
        </div>
        <div className={styles.bottomSheetBody}>
          {contexts?.length ? (
            <div className={styles.contextGrid}>
              {contexts.map(context => (
                <div key={context.id} className={styles.contextCard}>
                  <h3>{context.name}</h3>
                  <p>{context.description}</p>
                </div>
              ))}
            </div>
          ) : (
            <EmptyState
              title="No Contexts Found"
              text="You haven't created any contexts yet. Contexts help you organize and manage your features."
            >
              <button onClick={onCreateNew} className={styles.createButton}>
                <FiPlus />
                Create Context
              </button>
            </EmptyState>
          )}
        </div>
        {contexts?.length > 0 && (
          <div className={styles.bottomSheetFooter}>
            <button onClick={onCreateNew} className={styles.createButton}>
              <FiPlus />
              Create New Context
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContextBottomSheet; 